import { motion } from "framer-motion";
import s from "./styles.module.css";
import Gallery from "./Gallery/Gallery";
import { AndroidIcon, AppleIcon, FacebookIcon, InstaIcon, LinkedInIcon, PinterestIcon, TiktokIcon, TwitterIcon } from "../../../../../utils/Icons";

const fadeUp = {
    hidden: { opacity: 0, y: 22 },
    show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

export default function Slider() {
    const images = [
        "/assets/images/testimonial-slider-1.webp",
        "/assets/images/testimonial-slider-2.webp",
        "/assets/images/testimonial-slider-1.webp",
        "/assets/images/testimonial-slider-2.webp",
        "/assets/images/testimonial-slider-1.webp",
        "/assets/images/testimonial-slider-2.webp",
        "/assets/images/testimonial-slider-1.webp",
        "/assets/images/testimonial-slider-2.webp",
        "/assets/images/testimonial-slider-1.webp",
        "/assets/images/testimonial-slider-2.webp",
    ];

    return (
        <motion.section
            className={s.wrap}
            id="rates"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.15 }}
        >

            {/* Gallery fade-up */}
            <motion.div variants={fadeUp}>
                <Gallery images={images} />
            </motion.div>
            <motion.h1 className={s.subheading} variants={fadeUp}>
                Here’s What Our Customers Are Saying
            </motion.h1>
            <motion.div className={s.logos} variants={fadeUp}>
                <a href="https://www.facebook.com/fuel.clubs" target="_blank" rel="noreferrer">
                    <FacebookIcon />
                </a>
                <a href="https://www.instagram.com/fuelclubs/" target="_blank" rel="noreferrer">
                    <InstaIcon />
                </a>
                <a href="https://www.linkedin.com/in/fuelclubs-%E2%9B%BD%EF%B8%8F-729881379/" target="_blank" rel="noreferrer">
                    <LinkedInIcon />
                </a>
                <a href="https://www.tiktok.com/@fuelclubs" target="_blank" rel="noreferrer">
                    <TiktokIcon />
                </a>
                <a href="https://apps.apple.com/app/id6753362541" target="_blank" rel="noreferrer">
                    <AppleIcon />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.devzona.fuelclubs" target="_blank" rel="noreferrer">
                    <AndroidIcon />
                </a>
            </motion.div>


        </motion.section>
    );
}
